import axiosInstance from "./axiosInstance";
import baseUrl from "services/constants";

// generate/refresh access_token using refresh_token
export const generateToken = async (payload) => {
  try {
    const res = await axiosInstance.post(`/token-verify`, payload, {
      headers: { "x-skip-auth": "true" },
    });
    if (res.status === 200 || res.status === 201) {
      localStorage.setItem("access_token", res?.data?.data?.access_token);
      return res;
    } else {
      console.error("Failed to get access_token!");
      return null;
    }
  } catch (error) {
    console.error("error", error);
    return error?.response;
  }
};

// Register user API
export const registerUser = async (payload) => {
  try {
    const res = await axiosInstance.post(`/users`, payload);
    if (res.status === 200 || res.status === 201) {
      return res;
    } else {
      console.error("Failed to register user!");
      return null;
    }
  } catch (error) {
    console.error("error", error);
    return error?.response;
  }
};

// otp Verification
export const otpVerify = async (payload) => {
  try {
    const res = await axiosInstance.post(`/users/otp`, payload);
    if (res.status === 200 || res.status === 201) {
      return res;
    } else {
      console.error("Otp Verification Failed!");
      localStorage.setItem("logIn", false);
      return null;
    }
  } catch (error) {
    console.error("error", error);
    return error?.response;
  }
};

// Admin Login API
export const adminLogin = async (payload) => {
  try {
    const res = await axiosInstance.post(`/admin/login`, payload);
    if (res.status === 200 || res.status === 201) {
      return res;
    } else {
      console.error("Failed to login as admin!");
      localStorage.setItem("logIn", false);
      return null;
    }
  } catch (error) {
    console.error("error", error);
    return error?.response;
  }
};

// Member Login API
export const memberLogin = async (payload) => {
  try {
    const res = await axiosInstance.post(`/users/oauth`, payload);
    if (res.status === 200 || res.status === 201) {
      return res;
    } else {
      console.error("Failed to login!");
      localStorage.setItem("logIn", false);
      return null;
    }
  } catch (error) {
    console.error("error", error);
    return error?.response;
  }
};


// Fetch company configuration
export const getCompanyConfig = async () => {
  try {
    const res = await axiosInstance.get("/company-config", {
      headers: {
        "x-api-key": process.env.REACT_APP_API_KEY,
        "x-base-url": process.env.REACT_APP_COMPANY_URL,
      },
    });

    if (res.status === 200 || res.status === 201) {
      return res;
    } else {
      console.error("Failed to fetch company config!");
      return null;
    }
  } catch (error) {
    console.error("error", error);
    return error?.response;
  }
};
